
import React from 'react'

const ChevronRight = ({ className = "" }) => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M5.17192 6.99977L0.221923 2.04977L1.63592 0.635769L7.99992 6.99977L1.63592 13.3638L0.221924 11.9498L5.17192 6.99977Z" fill="currentColor" />
    </svg>
  )
}

export default ChevronRight